import { render, staticRenderFns } from "./Manufacturers.vue?vue&type=template&id=4a6c3b93&scoped=true&"
import script from "./Manufacturers.vue?vue&type=script&lang=js&"
export * from "./Manufacturers.vue?vue&type=script&lang=js&"
import style0 from "./Manufacturers.vue?vue&type=style&index=0&id=4a6c3b93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6c3b93",
  null
  
)

export default component.exports